module.exports = __webpack_public_path__ + "static/media/test.e4d9d5a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/test.mp4
// module id = MQ+I
// module chunks = 1